export default "__VITE_ASSET__CVTjUKto__"